import { styled } from 'linaria/react';

export const FakeModalFooter = styled.div`
  height: 40px;
`;
